import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 py-8 mt-auto">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-text-light text-sm">
            CloudFruit Hunts by{' '}
            <a
              href="https://cloudfruit.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary hover:text-primary"
            >
              CloudFruit LLC
            </a>
          </div>

          <nav className="flex items-center gap-6 text-sm">
            <Link to="/rules" className="text-text-light hover:text-primary">
              Official Rules
            </Link>
            <a
              href="https://cloudfruit.com/contact"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-light hover:text-primary"
            >
              Contact
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
